import DeviceChart from '../device-chart-component/device-chart/device-chart.component';
import './device-general-status.styles.scss';
import customCharts from '@lifepowr/components/src/utils/graphDescs/system';

import { connect } from 'react-redux';

const DeviceGeneralStatus = (props) => {
  const { deviceId, userMode, admin } = props;

  /** Info used to handle general status chart*/
  const chartProps = {
    socketUrl: 'test2',
    chartFlag: 'General Status',
    table: 'inverter',
    rtKey: 'inverter',
    customCharts,
    deviceId,
    userMode,
    admin,
  };

  return (
    <div className="device-general-status">
      <DeviceChart {...chartProps} />
    </div>
  );
};

export default connect(
  (state) => {
    const { shadow } = state.system || {};
    return { shadow };
  },
  null,
  null,
)(DeviceGeneralStatus);
